import { ChangeDetectorRef, Component, inject, OnInit } from '@angular/core'
import { BaseComponent } from './common/components/base.component'
import { filter, fromEvent } from 'rxjs'
import { BrowserPlatformLocation } from '@angular/common'
import { NavigationEnd } from '@angular/router'
import { WindowUnloadDirective } from './common/directives/window-unload.directive'
import { SSO_PENDING_KEY } from './common/services/sso-auth.service'
import { NavigationSpinnerService } from './common/services/navigation-spinner.service'
import { LiveLocationService } from './common/services/live-location.service'

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  hostDirectives: [WindowUnloadDirective],
  standalone: false
})

export class AppComponent extends BaseComponent implements OnInit {
  platformLocation = inject(BrowserPlatformLocation)
  changeDetection = inject(ChangeDetectorRef);
  navigationSpinnerService = inject(NavigationSpinnerService);
  readonly #liveLocationService = inject(LiveLocationService)

  backButtonDialog = false
  loadSpinner = false

  constructor() {
    super()
    this.navigationSpinnerService.init()
    this.subscriptions.add(this.router.events.pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.platformLocation.pushState(null, '', null)
      })
    )
    this.subscriptions.add(fromEvent(window, 'popstate').subscribe(() => {
      this.platformLocation.pushState(null, '', null)
      if (sessionStorage.getItem(SSO_PENDING_KEY)) {
        return
      }
      this.backButtonDialog = true
    }))


  }

  ngOnInit(): void {
    this.subscriptions.add(this.spinnerService.loading$.subscribe(loading => {
      this.loadSpinner = loading;
    }));

    this.#liveLocationService.startWatching()
  }

}